// Initialize Splide slider
const featured_product_tab_slider = document.querySelector('.featured-product-tab-wrapper .splide');
if (featured_product_tab_slider) {
  const splide = new Splide(featured_product_tab_slider, {
    type: 'slide',
    perPage: 4,
    gap: '3rem',
    autoplay: false,
    arrows: true,
    pagination: true,
    breakpoints: {
      1199: { perPage: 4, gap: '2rem' },
      1024: { perPage: 3, gap: '2rem' },
      767: { perPage: 2, gap: '1rem' },
      480: { perPage: 1, gap: '0.5rem' }
    }
  });
  splide.mount();
}

// --- DOM elements ---
const allTopProductCards = document.querySelectorAll('.display-current-prouduct .product-outer');
const allBottomProductCards = document.querySelectorAll('.featured_prouduct_splide li.splide__slide');
const ADD_TO_CART_BTN = document.querySelector('.display-current-prouduct .add-to-cart-button-wrapper button');
const QUANTITY_INP = document.querySelector('.quantity-seletion-box input');
const PLUS_BTN = document.querySelector('.quantity-seletion-box .plus-btn');
const MINUS_BTN = document.querySelector('.quantity-seletion-box .minus-btn');
const loadingSpnr = document.querySelector('.display-current-prouduct .add-to-cart-button-wrapper .svg-wrapper');

let currentQuantityValue = parseInt(QUANTITY_INP.value, 10) || 1;
let PRODUCT_ID = null;

// --- Utility functions ---
function getSelectedVariant() {
  const currentProduct = document.querySelector('.product-outer.is_currently_selected');

  // Case 1: Only default variant
  if (currentProduct?.dataset.onlyVaraintId) {
    return {
      dataset: {
        variantId: currentProduct.dataset.onlyVaraintId,
        variantAvaliable: currentProduct.dataset.avalbility,
        inventoryQuantity: currentProduct.dataset.inventoryQuantity,
        variantPrice: currentProduct.querySelector(".selected-variant-price")?.dataset.price || "",
        variantCompatePrice: currentProduct.querySelector(".selected-variant-price")?.dataset.compareAt || ""
      }
    };
  }

  // Case 2: Multiple variants
  const allVariants = currentProduct.querySelectorAll('.varinats_list p');
  const checkedRadio = currentProduct.querySelector('input[type="radio"]:checked');
  if (!checkedRadio) return null;

  const selectedValue = checkedRadio.value.trim();
  return Array.from(allVariants).find(v => v.dataset.variantTitle.trim() === selectedValue) || null;
}

function updateAvailabilityAndPrice() {
  const variant = getSelectedVariant();
  const currentProduct = document.querySelector('.product-outer.is_currently_selected');
  const priceWrapper = currentProduct.querySelector(".selected-variant-price");
  const imageWrapper = currentProduct.querySelector(".product_inner_right .image_wpr");

  if (!variant) return;

  // --- Update price ---
  const price = variant.dataset.variantPrice || "";
  const compareAt = variant.dataset.variantCompatePrice || "";

  if (compareAt && compareAt !== "$0.00" && compareAt !== price) {
    priceWrapper.innerHTML = `<span>${price}</span> <s>${compareAt}</s>`;
  } else {
    priceWrapper.textContent = price;
  }
  priceWrapper.style.display = "block";

  // --- Update availability ---
  const available = variant.dataset.variantAvaliable === "true";
  const inventoryQty = parseInt(variant.dataset.inventoryQuantity, 10) || 0;
  const outOfStock = !available || currentQuantityValue > inventoryQty;

  ADD_TO_CART_BTN.disabled = outOfStock;
  ADD_TO_CART_BTN.classList.toggle("disabled", outOfStock);
  ADD_TO_CART_BTN.querySelector("span").textContent = outOfStock ? "Out of Stock" : "Add to cart";

  PRODUCT_ID = variant.dataset.variantId;

  // --- Update image (smooth, no jerk) ---
  let imageUrl = variant.dataset.variantImage || variant.dataset.productImage || "";
  if (imageWrapper) {
    let imgEl = imageWrapper.querySelector("img");

    if (imageUrl) {
      if (!imgEl) {
        imgEl = document.createElement("img");
        imgEl.alt = "Selected variant image";
        imgEl.loading = "eager";
        imgEl.style.width = "100%";
        imgEl.style.height = "auto";
        imgEl.style.transition = "opacity 0.3s ease"; // fade effect
        imgEl.style.opacity = "0";
        imgEl.onload = () => { imgEl.style.opacity = "1"; };
        imageWrapper.appendChild(imgEl);
      }
      imgEl.src = imageUrl;
      imageWrapper.classList.remove("hidden");
    } else {
      if (imgEl) imgEl.remove();
      imageWrapper.classList.add("hidden");
    }
  }
}

// --- Bind events ---
function bindVariantEvents() {
  const currentProduct = document.querySelector('.product-outer.is_currently_selected');

  const radios = currentProduct.querySelectorAll('input[type="radio"]');
  radios.forEach(radio => radio.addEventListener("change", updateAvailabilityAndPrice));

  updateAvailabilityAndPrice();
}

// --- Quantity handlers ---
function changeQuantity(amount) {
  currentQuantityValue = parseInt(QUANTITY_INP.value, 10) || 1;
  currentQuantityValue = Math.max(1, currentQuantityValue + amount);
  QUANTITY_INP.value = currentQuantityValue;
  updateAvailabilityAndPrice();
}

PLUS_BTN.addEventListener('click', () => changeQuantity(1));
MINUS_BTN.addEventListener('click', () => changeQuantity(-1));
QUANTITY_INP.addEventListener('input', () => {
  currentQuantityValue = parseInt(QUANTITY_INP.value, 10) || 1;
  updateAvailabilityAndPrice();
});

// --- Tab switching ---
allBottomProductCards.forEach((card, index) => {
  card.addEventListener('click', () => {
    allBottomProductCards.forEach(c => c.classList.remove('is_currently_selected'));
    allTopProductCards.forEach(c => c.classList.remove('is_currently_selected'));

    card.classList.add('is_currently_selected');
    allTopProductCards[index].classList.add('is_currently_selected');

    currentQuantityValue = 1;
    QUANTITY_INP.value = currentQuantityValue;
    bindVariantEvents();

    // Scroll only on mobile to prevent jerk
    const section = document.querySelector('.featured-product-tab-wrapper .content-right');
    if (section) {
      section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
});

// --- Add to cart ---
ADD_TO_CART_BTN.addEventListener('click', () => {
  const cartDrawer = document.querySelector("cart-drawer");
  currentQuantityValue = parseInt(QUANTITY_INP.value, 10) || 1;

  if (!PRODUCT_ID) return console.error("No PRODUCT_ID found!");

  ADD_TO_CART_BTN.disabled = true;
  ADD_TO_CART_BTN.classList.add("loading");
  loadingSpnr.classList.remove("hidden");
  ADD_TO_CART_BTN.querySelector("span").classList.add("hidden");

  fetch(`${window.Shopify.routes.root}cart/add.js`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ 
      items: [{ id: PRODUCT_ID, quantity: currentQuantityValue }],
      sections: cartDrawer?.getSectionsToRender().map(s => s.id),
      sections_url: window.location.pathname
    }),
  })
  .then(r => r.json())
  .then(data => {
    cartDrawer.renderContents(data);
    setTimeout(() => { cartDrawer.classList.add("animate", "active"); });
    cartDrawer.classList.remove("is-empty");
  })
  .catch(console.error)
  .finally(() => {
    ADD_TO_CART_BTN.disabled = false;
    ADD_TO_CART_BTN.classList.remove("loading");
    loadingSpnr.classList.add("hidden");
    ADD_TO_CART_BTN.querySelector("span").classList.remove("hidden");
  });
});

// --- Init ---
bindVariantEvents();
